import { render } from "./MoreMenu.vue?vue&type=template&id=27073348"
import script from "./MoreMenu.vue?vue&type=script&lang=js"
export * from "./MoreMenu.vue?vue&type=script&lang=js"

import "./MoreMenu.vue?vue&type=style&index=0&id=27073348&lang=scss"
script.render = render

export default script